import React, { Component, useState, useEffect,  } from 'react';
import HeaderPage from '../../Components/HeaderPages';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Spinner  } from "react-awesome-spinners";
import Aviso from '../../Components/Aviso';
import CaixaInforme from '../../Components/CaixaInforme';
import Butao from '../../Components/Butao_list';
import Select from '../../Components/Select';
import Pagination from '../../Components/Pagination';
import TACriarClentes from './TACriarClentes';
import TAPagarTiketRepre from './TAPagarTiketRepre';
import TAVerTiketRepre from './TAVerTiketRepre';
import Api from '../../Api';
import FinderSelect from 'react-finderselect';
import DataTime from '../../Components/TADateFormat';
import { DatePicker, DatePickerInput } from 'rc-datepicker';


export default ({IdConta, IdUse, CidEst, Dados, setDados, Loading,  setLoading,  Alert, setAlert, AlertTipo,
   setAlertTipo, Avisando, setAvisando}) => {
      const [Offset, setOffset] = useState(0);
      const [Limit, setLimit] = useState(10);
      const [Quant, setQuant] = useState(0);
      const [Pag1, setPag1] = useState(false);
      const [Pag2, setPag2] = useState(false);
      const [Pag3, setPag3] = useState(false);
      const [Pag4, setPag4] = useState(false);
      const [Titulo, setTitulo] = useState("Pagamentos");
      const [Time, setTime] = useState("")
      const [UsuariosContServ, setUsuariosContServ] = useState([]);
      const [Lista, setLista] = useState(["list"]);
      const [Carreg, setCarreg] = useState(false);
      const [Cont, setCont] = useState(0);
      const [Id, setId] = useState("");
      const [Nome, setNome] = useState("");
      const [AddList, setAddList] = useState(null);
      const [ResuComp, setResuComp] = useState("");
      const [VerResuComp, setVerResuComp] = useState(false);
      const [ListEsp, setListEsp] = useState({});
      const [ListCliente, setListCliente] = useState([]);
      const [Cliente, setCliente] = useState("");
      const [ListTel, setListTel] = useState([]);
      const [Telefone, setTelefone] = useState("");
      const [DataP, setDataP] = useState(new Date().getTime()-432000000);
      const [DataA, setDataA] = useState(new Date().getTime());
      const [VerA, setVerA] = useState(false);
      const [VerD, setVerD] = useState(false);
      const [DataIni, setDataIni] = useState(new Date().getTime()-432000000);
      const [DataFim, setDataFim] = useState(new Date().getTime());
      const [IdContRes, setIdContRes] = useState("");
      const [ListPago, setListPago] = useState([
        {id:"1", select:"Pago"},
        {id:"1", select:"Não Pago"},
      ]);
      const [Pago, setPago] = useState("");
      useEffect(() => {
       ListApp();     
      }, [DataFim, DataIni ])
      useEffect(() => {
       FuncaoData();     
      }, [])
      useEffect(() => {
         if(AddList !== null){
          AdicionandoLista()
          
         }
       }, [AddList])
      useEffect(() => {
    
       }, [Lista])

      useEffect(() => {
      
        Listando(); 
        
       }, [UsuariosContServ])

       useEffect(() => {
        Listando();
       }, [Offset])
     
        useEffect(() => {
            if(Cliente !== ""  ){
                PesCliente();
            }
           }, [Cliente])
        useEffect(() => {
            if(Telefone !== ""  ){
                PesTelefone();
            }
           }, [Telefone])
         useEffect(() => {
            if(Pago !== ""  ){
                PesPago();
            }
           }, [Pago])

             const  PesPago = ()=>{
              
             
              let listra1 = [];
              if(Pago === "Pago"){
                 for(let i in UsuariosContServ ) {
                  if( UsuariosContServ[i].Pago === true) {
                    listra1.push({

                      Id: UsuariosContServ[i].Id,
                      Nome: UsuariosContServ[i].Nome,  
                      Telefone: UsuariosContServ[i].Telefone,  
                      TempLimitAtiv: UsuariosContServ[i].TempLimitAtiv,
                      IdConta:UsuariosContServ[i].IdConta,
                      Pago:UsuariosContServ[i].Pago,
                      Mensalidade:UsuariosContServ[i].Mensalidade,
                      ValorTotal:UsuariosContServ[i].ValorTotal,
                      NomeCli:UsuariosContServ[i].NomeCli,
                      TelCli:UsuariosContServ[i].TelCli,
                      PorcenMens:UsuariosContServ[i].PorcenMens,
                      IdRepresentante:UsuariosContServ[i].IdRepresentante,   
                      ExtratoImg:UsuariosContServ[i].ExtratoImg,
                      


                  });  
                  
                  }
                
                }

              } else{
  
              for(let i in UsuariosContServ ) {
                  if( UsuariosContServ[i].Pago === false) {
                    listra1.push({

                     Id: UsuariosContServ[i].Id,
                      Nome: UsuariosContServ[i].Nome,  
                      Telefone: UsuariosContServ[i].Telefone,  
                      TempLimitAtiv: UsuariosContServ[i].TempLimitAtiv,
                      IdConta:UsuariosContServ[i].IdConta,
                      Pago:UsuariosContServ[i].Pago,
                      Mensalidade:UsuariosContServ[i].Mensalidade,
                      ValorTotal:UsuariosContServ[i].ValorTotal,
                      NomeCli:UsuariosContServ[i].NomeCli,
                      TelCli:UsuariosContServ[i].TelCli,
                      PorcenMens:UsuariosContServ[i].PorcenMens,
                      IdRepresentante:UsuariosContServ[i].IdRepresentante,   
                      ExtratoImg:UsuariosContServ[i].ExtratoImg,
                      
                  });  
                   
                  }
                
                }

                }
                setCarreg(false)
                 setLista(["list"]);
                 setQuant(listra1.length);
                setUsuariosContServ(listra1);
                
              
             
             
               
            } 

             const PesCliente = ()=>{
              
             
              let listra1 = [];
              
              for(let i in UsuariosContServ ) {
                  if( UsuariosContServ[i].Nome.toLowerCase().includes(Cliente.toLowerCase() ) ) {
                    listra1.push({

                     Id: UsuariosContServ[i].Id,
                      Nome: UsuariosContServ[i].Nome,  
                      Telefone: UsuariosContServ[i].Telefone,  
                      TempLimitAtiv: UsuariosContServ[i].TempLimitAtiv,
                      IdConta:UsuariosContServ[i].IdConta,
                      Pago:UsuariosContServ[i].Pago,
                      Mensalidade:UsuariosContServ[i].Mensalidade,
                      ValorTotal:UsuariosContServ[i].ValorTotal,
                      NomeCli:UsuariosContServ[i].NomeCli,
                      TelCli:UsuariosContServ[i].TelCli,
                      PorcenMens:UsuariosContServ[i].PorcenMens,
                      IdRepresentante:UsuariosContServ[i].IdRepresentante,   
                      ExtratoImg:UsuariosContServ[i].ExtratoImg,
                      
                  });  
                   setTelefone(UsuariosContServ[i].Telefone)
                  }
                
                }
                
                setCarreg(false)
                 setLista(["list"]);
                 setQuant(listra1.length);
                setUsuariosContServ(listra1);
                
              
             
             
               
            } 
     
          const PesTelefone = ()=>{
              
             
              let listra1 = [];
              
              for(let i in UsuariosContServ ) {
                  if( UsuariosContServ[i].Telefone.toLowerCase().includes(Telefone.toLowerCase() ) ) {
                    listra1.push({
  
                     Id: UsuariosContServ[i].Id,
                      Nome: UsuariosContServ[i].Nome,  
                      Telefone: UsuariosContServ[i].Telefone,  
                      TempLimitAtiv: UsuariosContServ[i].TempLimitAtiv,
                      IdConta:UsuariosContServ[i].IdConta,
                      Pago:UsuariosContServ[i].Pago,
                      Mensalidade:UsuariosContServ[i].Mensalidade,
                      ValorTotal:UsuariosContServ[i].ValorTotal,
                      NomeCli:UsuariosContServ[i].NomeCli,
                      TelCli:UsuariosContServ[i].TelCli,
                      PorcenMens:UsuariosContServ[i].PorcenMens,
                      IdRepresentante:UsuariosContServ[i].IdRepresentante,   
                      ExtratoImg:UsuariosContServ[i].ExtratoImg,
                      
                  });  
                 setCliente(UsuariosContServ[i].Nome) 
                  }
                 
                }
                
                setCarreg(false)
                 setLista(["list"]);
                 setQuant(listra1.length);
                setUsuariosContServ(listra1);
                
              
             
             
               
            } 
           const FuncaoData = async ()=>{
           

               
          }
     
          const ListApp = async ()=>{
            if (navigator.onLine) {
             setCarreg(true);
             await Api.TAListPagamentos(Dados, IdContRes, DataFim, DataIni, IdConta, setQuant, setUsuariosContServ, setListCliente, setListTel, setCarreg);
             
            } else {
              setAlert("Sem Internet");
              setAlertTipo("danger");
            }

               
          }
        const AdicionandoLista = async ()=>{
          if(Lista[0] === "list"){
            setLista([
              {
                list:AddList
              }]);

          } else {
          setLista([
              {
                list:AddList
              },
              ...Lista,
            ]);
          }
          
        
          }

          const Listando = async ()=>{
                
                  const cal1 = Quant/Limit;
                  const cal2 = Math.trunc(cal1);
                  const cal3 = cal2*10;
                  const cal4 = Quant - cal3;
                  if(Offset === cal3) {
                      
                          const inicio = Offset;
                          const fim = Quant;
                          var Listinha =[];
                          for (var i = inicio; i < fim; i++) {
                            Listinha.push({
                              list:UsuariosContServ[i],
                            });
                            setLista(Listinha);
                          
                    

                          }

                  } else {

                          const inicio = Offset;
                          const fim = (Offset + Limit) 
                          var Listinha =[];
                          for (var i = inicio; i < fim; i++) {
                            Listinha.push({
                              list:UsuariosContServ[i],
                            });
                            setLista(Listinha);
                           
                   

                        }
                  

                    } 

                    var num= Cont + 1;
                    setCont(num);
                    if(Cont === 1){
                      setCarreg(false); 
                    }          
                         
          }

          function confirma() {
            setAlert(" ");
            setAlertTipo(" ");
            setPag2(false);
            setPag1(false);
           
          }
          function cancelar() {
            setAlert(" ");
            setAlertTipo(" ");
            setPag2(false);
            setPag1(false);
          }

          const Fechar = ()=>{
            setPag2(false);
            setPag1(false);
            setPag3(false);
            setPag4(false);
          }


               
               


                

         

               const Pagina1 = async (id , Lista)=>{
                 setPag1(true);
                 await setId(id);
                 await setListEsp(Lista);
               }

                const Pagina3 = async ()=>{
              
                setPag1(true);
                setPag2(true);
                setPag3(true);
              }

              const Pagina4 = async (id)=>{
                setId(id);
                setPag1(true);
                setPag2(true);
                setPag3(true);
                setPag4(true);
              }

               const Pagina2 = async (id , Lista)=>{
                await setId(id);
                await setPag1(true);
                await setPag2(true);
                await setListEsp(Lista);

              }

                const MsgDesativar = (id, nome)=>{
                  setId(id);
                  setNome(nome);
                  setAlert("Ok");
                  setAlertTipo("Desativar");
                  
                }

                const Desativar = async (Id, nome)=>{
                 
                  setAlert(" ");
                  setAlertTipo(" ");
       
              if (navigator.onLine) {
                 const novaLista = UsuariosContServ.map(item =>
                item.Id === Id ? { ...item, Ativo:false } : item
              );
                setUsuariosContServ(novaLista);
                await Api.TADesativandoClientes(Dados, Id, setAlertTipo, setAlert);

                
               } else {
                 setAlert("Sem Internet");
                 setAlertTipo("danger");
               }


                }

                const MsgAtivar = (id, nome)=>{
                  setId(id);
                  setNome(nome);
                  setAlert("Ok");
                  setAlertTipo("ativar");
                  
                }

                 const Ativar = async (Id, nome)=>{
                 
                  setAlert(" ");
                  setAlertTipo(" ");
       
              if (navigator.onLine) {
                 const novaLista = UsuariosContServ.map(item =>
                item.Id === Id ? { ...item, Ativo:true } : item
              );
                setUsuariosContServ(novaLista);
                await Api.TAAtivandoClientes(Dados, Id, setAlertTipo, setAlert);

                
               } else {
                 setAlert("Sem Internet");
                 setAlertTipo("danger");
               }


                }
                 const LimpandoPesq = ()=>{
                    ListApp() 
                    setCliente("")
                    setTelefone("")
                    setPago("")
                  }
                const printValue3 = (target) => {
                    
                    for(let i in ListCliente){
                    
                      if(ListCliente[i].select === target.value){  
                      setCliente(ListCliente[i].select)
                      setIdContRes(ListCliente[i].id)
                      }
                    
                    }
            
              
                }
                const printValue4 = (target) => {
                    
                    for(let i in ListTel){
                    
                      if(ListTel[i].select === target.value){  
                      setTelefone(ListTel[i].select)
                      setIdContRes(ListTel[i].id)
                      }
                    
                    }
            
              
                }
                const printValue5 = (target) => {
                    setPago(target.value)

                }
                  const datando = async (jsDate, dateString)=>{
                       
                        
                        let currentDate = '';
                        let now =new Date(jsDate);
                        let Dia = now.getDate();
                        let Mes = (now.getMonth()+1);
                        let Ano = now.getFullYear();
                        Dia = Dia < 10 ? '0'+Dia : Dia;
                        Mes = Mes < 10 ? '0'+Mes : Mes;
                        currentDate = Ano+'-'+Mes+'-'+Dia;
                        let Dat  = new Date(currentDate +" 00:00:00.000").getTime();
                     
                        let Dat2 = new Date().getTime();
                       
                          setDataP(jsDate)
                          setDataIni(Dat)
                         setLista(["list"]); 
                         setCliente("")
                       setTelefone("")
                       setPago("")
                    }
                     const datando2 = async (jsDate, dateString)=>{
                    
                        
                        let currentDate = '';
                        let now =new Date(jsDate);
                        let Dia = now.getDate();
                        let Mes = (now.getMonth()+1);
                        let Ano = now.getFullYear();
                        Dia = Dia < 10 ? '0'+Dia : Dia;
                        Mes = Mes < 10 ? '0'+Mes : Mes;
                        currentDate = Ano+'-'+Mes+'-'+Dia;
                        let Dat  = new Date(currentDate +" 23:59:00.000").getTime();
                    
                          setDataA(jsDate)
                          setDataFim(Dat)
                       setTelefone("")
                       setCliente("")
                        setLista(["list"]); 
                        setPago("")
                    }
      
  return (
        
          <div>
             {Alert !== " " && AlertTipo === "success" &&
                  <SweetAlert  success title={Alert} onConfirm={confirma} onCancel={cancelar} />
                }

            {Alert !== " " && AlertTipo === "danger" &&
                  <SweetAlert  danger title={Alert} confirmBtnBsStyle="danger" onConfirm={confirma} onCancel={cancelar} />
                }


            { Alert !== " " && AlertTipo === "Desativar" &&
              <SweetAlert
              warning
              showCancel
              confirmBtnText="Sim"
              cancelBtnText="Não"
              confirmBtnBsStyle="danger"
              onConfirm={()=>Desativar()}
              onCancel={cancelar}
              focusCancelBtn
            >
              Tem certeza que deseja Desativar a condicional {Nome}!
            </SweetAlert>
            }
            { Alert !== " " && AlertTipo === "ativar" &&
              <SweetAlert
              warning
              showCancel
              confirmBtnText="Sim"
              cancelBtnText="Não"
              confirmBtnBsStyle="danger"
              onConfirm={()=>Ativar()}
              onCancel={cancelar}
              focusCancelBtn
            >
              Tem certeza que deseja ativar a condicional {Nome}!
            </SweetAlert>
            }
            { Pag1 === false ?
            <div className="content-wrapper">
               
              <HeaderPage
              Avisando={Avisando} 
              Titulo={Titulo}
              />            
              <section className="content">
                <div className="container-fluid">
                  
                <div className="row">
                  <section className="col-12">
                  {Loading === true ?
                        <Spinner 
                        size={64}
                        color={"#5d0bf7"}
                        sizeUnit={'px'} 
                        />
                        :
                        <>
                         <div className="row">
                                <CaixaInforme 
                                cor={"small-box bg-warning"}
                                valor={Quant}
                                porcentagen={false}
                                nome={"Quant. Pag. na Lista"}
                                icon={"fas fa-donate"}
                                link={false}
                                />
                                              {/* <CaixaInforme 
                                              cor={"small-box bg-success"}
                                              valor={"53"}
                                              porcentagen={true}
                                              nome={"Rendimentos"}
                                              icon={"ion ion-stats-bars"}
                                              link={false}
                                              />
                                              <CaixaInforme 
                                              cor={"small-box bg-warning"}
                                              valor={"44"}
                                              porcentagen={false}
                                              nome={"Contas Subordinadas"}
                                              icon={"ion ion-person-add" }
                                              link={false}
                                              />
                                              <CaixaInforme 
                                              cor={"small-box bg-danger"}
                                              valor={"65"}
                                              porcentagen={false}
                                              nome={"Visitas"}
                                              icon={"ion ion-pie-graph"}
                                              link={false}
                                              />                            */}
                                           </div>
                     <div className="card card-info">
                    <div className="card-header">
                        <h3 className="card-title">Filtros para pesquisa</h3>
                    </div>
                    {/* /.card-header */}
                    
                    <div className="card-body">
                      {/* <h3 className="card-title" style={{color:"#000"}}>Filtros para pesquisa</h3> */}
                       <div className="row" >
                       <div className="col-sm-3">
                        <div className="form-group">
                            <label>Iníco Da Data de Vencimento</label>
                            <DatePickerInput
                            onChange={datando}
                            value={DataP}
                            className='my-custom-datepicker-component'
                            disabled={VerD}
                            
                          />
                        </div>
                        </div> 
                        <div className="col-sm-3">
                        <div className="form-group">
                            <label>Fim Da Data de Vencimento</label>
                            <DatePickerInput
                            onChange={datando2}
                            value={DataA}
                            className='my-custom-datepicker-component'
                            disabled={VerA}
                            
                          />
                        </div>
                        </div>
                        </div>
                        {ListCliente.length !== 0 &&
                    <div className="row" >
                     <br />
                    <div className="col-sm-4">
                        <div className="form-group">
                          {ListCliente.length !== 0 &&
                      <>
                        <strong>Nome do Cliente</strong><br />
                        <div className="input_cadatro">
                        {Cliente ?
                        <>
                          <string style={{}}>{Cliente}</string><br />
                        </>
                        :  
                        <FinderSelect 
                        data={ListCliente} 
                        label='select'
                        value = 'select'  
                        extraInfo='capital' 
                        name='country' 
                        className='anyClass' 
                        placeholder="Escolha o Cliente"
                        onClick={() => console.log('entering')} 
                        onChange={(target) => printValue3(target)}

                      />
                        }
                      </div> 
                </>
                    }
                            
                          
                        </div>
                        </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          {ListTel.length !== 0 &&
                      <>
                        <strong>Numero do Telefone</strong><br />
                        <div className="input_cadatro">
                        {Telefone ?
                        <>
                          <string style={{}}>{Telefone}</string><br />
                        </>
                        :  
                        <FinderSelect 
                        data={ListTel} 
                        label='select'
                        value = 'select'  
                        extraInfo='capital' 
                        name='country' 
                        className='anyClass' 
                        placeholder="Escolha o Telefone"
                        onClick={() => console.log('entering')} 
                        onChange={(target) => printValue4(target)}

                      />
                        }
                      </div> 
                </>
                    }
                            
                          
                        </div>
                        </div>
                         <div className="col-sm-4">
                        <div className="form-group">
                          {ListPago.length !== 0 &&
                      <>
                        <strong>Ticket </strong><br />
                        <div className="input_cadatro">
                        {Pago ?
                        <>
                          <string style={{}}>{Pago}</string><br />
                        </>
                        :  
                        <FinderSelect 
                        data={ListPago} 
                        label='select'
                        value = 'select'  
                        extraInfo='capital' 
                        name='country' 
                        className='anyClass' 
                        placeholder="Escolha a Situação do Ticket"
                        onClick={() => console.log('entering')} 
                        onChange={(target) => printValue5(target)}

                      />
                        }
                      </div> 
                </>
                    }
                            
                          
                        </div>
                        </div>

                        <div className="col-sm-4">
                            <div className="form-group" style={{marginTop:22}}>
                              
                            <Butao 
                            style={"btn btn-sm btn-secondary"}
                            titulo={"Limpar Pesquisa"}
                            onClick={()=>LimpandoPesq()}
                            />
                            </div>
                            </div> 


                    </div>
                        }
                    </div>
                    </div>
                    <div className="card card-danger">
                     
                        {/* <div style={{margin:"10px", width:"250px"}}>
                        <Butao 
                        style={"btn btn-sm btn-info"}
                        titulo={"Criar Clientes"}
                        onClick={()=>Pagina1()}
                        />

                        </div> */}
                      
                      <div className="card-header">
                      
                        <h3 className="card-title" style={{ marginBottom: "10px"}}>Lista de Pagamentos </h3> 

                      </div>
                        <div class="card-body table-responsive p-0">
                          <table class="table table-hover text-nowrap">
                            <thead>
                              <tr>
                                <th>Ações</th>
                                <th>Data do Vencimento</th> 
                                <th>Nome</th> 
                                <th>Telefone</th>
                                <th>Pago</th>
                                
                              </tr>
                            </thead>
                            
                            { Lista[0].list ?
                            <tbody >
                            {Lista.map((item, key)=>(
                            
                            
                                    <tr key={item.list.Id} style={{backgroundColor: item.list.Pago === true ?"#b0e4b2":item.list.TempLimitAtiv > new Date().getTime() ?"#fff":item.list.TempLimitAtiv+432000000 > new Date().getTime() ?"#F4B0B9":"#b4b3b3"}} >
                                     <td>
                                    
                                    {item.list.Pago===true ?
                                    <>  
                                    <Butao 
                                      style={"btn btn-xs btn-success"}
                                      titulo={"Vizualizar"}
                                      onClick={()=>Pagina1(item.list.Id, item.list)}
                                      /> 
                          
                                      </>
                                      :
                                      <>
                                  
                                      <Butao 
                                      style={"btn btn-xs btn-warning"}
                                      titulo={"Pagar"}
                                      onClick={()=>Pagina2(item.list.Id, item.list)}
                                      /> 
                            
                                      </>
                                    }                                     
                                                           
                                    </td>
                                    <td>
                                      <DataTime 
                                      DateIni={item.list.TempLimitAtiv/1000}
                                      /></td>
                                    <td>{item.list.Nome}</td>
                                   
                                    <td>

                                     {item.list.Telefone}                            
                                                               
                                    </td>
                                    

                                     {item.list.Pago ?
                                     <td> Sim</td>
                                      :
                                      
                                      <td>Não </td>
                                      }                            
                                                               
                                   
                                   
                                  </tr>
                                 
                             ))}
                                </tbody> 
                                :
                                      <>
                                      { Carreg === true ?
                                        <Spinner 
                                        size={64}
                                        color={"#5d0bf7"}
                                        sizeUnit={'px'} 
                                        />
                                        :                                      
                                      <p style={{color:"red", margin:"20px"}}>Não existe Tiket Cadastrado</p>
                                      }
                                      </>
                            }
                            
                            
                          </table>
                            <Pagination
                            limit={Limit} 
                            total={Quant} 
                            offset={Offset}
                            setOffset={setOffset}
                            />
                         </div>
                        </div>
                       
                        </>
                        }
                    </section>       
               </div>
            </div>
          </section>
        </div>
        :
        <>
        {Pag2 === false ?
         <TAVerTiketRepre 
            setUsuariosContServ={setUsuariosContServ}
            UsuariosContServ={UsuariosContServ}
            setAlert={setAlert}
            setAlertTipo={setAlertTipo}
            Avisando={Avisando}
            Fechar={Fechar}
            Dados={Dados}
            Id={Id}
            ListEsp={ListEsp}
            
            />
          :
          <>
          {Pag3 === false ?
             <TAPagarTiketRepre 
            setUsuariosContServ={setUsuariosContServ}
            UsuariosContServ={UsuariosContServ}
            setAlert={setAlert}
            setAlertTipo={setAlertTipo}
            Avisando={Avisando}
            Fechar={Fechar}
            Dados={Dados}
            Id={Id}
            ListEsp={ListEsp}
            
            />
          :
          <>
           {Pag4 === false ?
           <>

           </>
          :
          <>

          </>
           }
          </>
          }
          </>
         
        }
        
        </>
   
         }
      </div>

        );
    }

